"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _PatientInfoDtoV = _interopRequireDefault(require("../model/PatientInfoDtoV2"));

var _PatientInfoEntityDtoV = _interopRequireDefault(require("../model/PatientInfoEntityDtoV2"));

var _PatientInfoEntityDtoV2PaginatedList = _interopRequireDefault(require("../model/PatientInfoEntityDtoV2PaginatedList"));

var _PatientInfoMetadataDtoV = _interopRequireDefault(require("../model/PatientInfoMetadataDtoV2"));

var _PatientInformationSearchFilter = _interopRequireDefault(require("../model/PatientInformationSearchFilter"));

var _StatusMessageDto = _interopRequireDefault(require("../model/StatusMessageDto"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* PatientInfo service.
* @module 2/PatientInfoApi
* @version 5.0.15
*/
var PatientInfoApi = /*#__PURE__*/function () {
  /**
  * Constructs a new PatientInfoApi. 
  * @alias module:2/PatientInfoApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function PatientInfoApi(apiClient) {
    _classCallCheck(this, PatientInfoApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Gets a paginated list of available patient information. (Requires: Roles -> RH.PI.ReadList, RH.PI.L, RH.PI.Admin).
   * @param {Object} opts Optional parameters
   * @param {Number} opts.pageIndex Index of the page. The first page has index zero. (default to 0)
   * @param {Number} opts.pageSize Size of the page, that is the number of objects on a page. (default to 20)
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PatientInfoEntityDtoV2PaginatedList} and HTTP response
   */


  _createClass(PatientInfoApi, [{
    key: "patientinfoGetWithHttpInfo",
    value: function patientinfoGetWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'pageIndex': opts['pageIndex'],
        'pageSize': opts['pageSize']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _PatientInfoEntityDtoV2PaginatedList["default"];
      return this.apiClient.callApi('/patientinfo', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Gets a paginated list of available patient information. (Requires: Roles -> RH.PI.ReadList, RH.PI.L, RH.PI.Admin).
     * @param {Object} opts Optional parameters
     * @param {Number} opts.pageIndex Index of the page. The first page has index zero. (default to 0)
     * @param {Number} opts.pageSize Size of the page, that is the number of objects on a page. (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PatientInfoEntityDtoV2PaginatedList}
     */

  }, {
    key: "patientinfoGet",
    value: function patientinfoGet(opts) {
      return this.patientinfoGetWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Deletes the patient information with the specified identifier. (Requires: Roles -> RH.PI.Delete, RH.PI.D, RH.PI.Admin).
     * @param {String} id The patient info identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "patientinfoIdDeleteWithHttpInfo",
    value: function patientinfoIdDeleteWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientinfoIdDelete");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = null;
      return this.apiClient.callApi('/patientinfo/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Deletes the patient information with the specified identifier. (Requires: Roles -> RH.PI.Delete, RH.PI.D, RH.PI.Admin).
     * @param {String} id The patient info identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "patientinfoIdDelete",
    value: function patientinfoIdDelete(id) {
      return this.patientinfoIdDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Gets the patient information with the specified identifier. (Requires: Roles -> RH.PI.Read, RH.PI.R, RH.PI.L, RH.PI.Admin).
     * @param {String} id The patient info identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PatientInfoEntityDtoV2} and HTTP response
     */

  }, {
    key: "patientinfoIdGetWithHttpInfo",
    value: function patientinfoIdGetWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientinfoIdGet");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _PatientInfoEntityDtoV["default"];
      return this.apiClient.callApi('/patientinfo/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Gets the patient information with the specified identifier. (Requires: Roles -> RH.PI.Read, RH.PI.R, RH.PI.L, RH.PI.Admin).
     * @param {String} id The patient info identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PatientInfoEntityDtoV2}
     */

  }, {
    key: "patientinfoIdGet",
    value: function patientinfoIdGet(id) {
      return this.patientinfoIdGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Updates the patient information with the specified identifier. (Requires: Roles -> RH.PI.Update, RH.PI.U, RH.PI.Admin).
     * This operation expects the complete patient information record to be provided  to enable detection of all updated information, including potentially removed  properties.  The data and time of the last modification must exactly match the value which  has been receivend upon loading the record. This is important to enable detection  of potential version conflicts in case the record might get modified by multiple  users simultaneously.
     * @param {String} id The patient info identifier.
     * @param {Date} dateTimeLastModified The date and time when the patient information was last modified.
     * @param {module:model/PatientInfoDtoV2} patientInfoDtoV2 The patient information to update.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PatientInfoMetadataDtoV2} and HTTP response
     */

  }, {
    key: "patientinfoIdPutWithHttpInfo",
    value: function patientinfoIdPutWithHttpInfo(id, dateTimeLastModified, patientInfoDtoV2) {
      var postBody = patientInfoDtoV2; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling patientinfoIdPut");
      } // verify the required parameter 'dateTimeLastModified' is set


      if (dateTimeLastModified === undefined || dateTimeLastModified === null) {
        throw new Error("Missing the required parameter 'dateTimeLastModified' when calling patientinfoIdPut");
      } // verify the required parameter 'patientInfoDtoV2' is set


      if (patientInfoDtoV2 === undefined || patientInfoDtoV2 === null) {
        throw new Error("Missing the required parameter 'patientInfoDtoV2' when calling patientinfoIdPut");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {
        'dateTimeLastModified': dateTimeLastModified
      };
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _PatientInfoMetadataDtoV["default"];
      return this.apiClient.callApi('/patientinfo/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Updates the patient information with the specified identifier. (Requires: Roles -> RH.PI.Update, RH.PI.U, RH.PI.Admin).
     * This operation expects the complete patient information record to be provided  to enable detection of all updated information, including potentially removed  properties.  The data and time of the last modification must exactly match the value which  has been receivend upon loading the record. This is important to enable detection  of potential version conflicts in case the record might get modified by multiple  users simultaneously.
     * @param {String} id The patient info identifier.
     * @param {Date} dateTimeLastModified The date and time when the patient information was last modified.
     * @param {module:model/PatientInfoDtoV2} patientInfoDtoV2 The patient information to update.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PatientInfoMetadataDtoV2}
     */

  }, {
    key: "patientinfoIdPut",
    value: function patientinfoIdPut(id, dateTimeLastModified, patientInfoDtoV2) {
      return this.patientinfoIdPutWithHttpInfo(id, dateTimeLastModified, patientInfoDtoV2).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Adds the specified patient information. (Requires: Roles -> RH.PI.Create, RH.PI.C, RH.PI.Admin).
     * This operation cannot detect whether information for the same patient might have  been stored before, since the patient information does not include any identifier  which is guaranteed to be globally unique. Therefore a new patient information  record gets created for each storage request.
     * @param {module:model/PatientInfoDtoV2} patientInfoDtoV2 The patient information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PatientInfoMetadataDtoV2} and HTTP response
     */

  }, {
    key: "patientinfoPostWithHttpInfo",
    value: function patientinfoPostWithHttpInfo(patientInfoDtoV2) {
      var postBody = patientInfoDtoV2; // verify the required parameter 'patientInfoDtoV2' is set

      if (patientInfoDtoV2 === undefined || patientInfoDtoV2 === null) {
        throw new Error("Missing the required parameter 'patientInfoDtoV2' when calling patientinfoPost");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _PatientInfoMetadataDtoV["default"];
      return this.apiClient.callApi('/patientinfo', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Adds the specified patient information. (Requires: Roles -> RH.PI.Create, RH.PI.C, RH.PI.Admin).
     * This operation cannot detect whether information for the same patient might have  been stored before, since the patient information does not include any identifier  which is guaranteed to be globally unique. Therefore a new patient information  record gets created for each storage request.
     * @param {module:model/PatientInfoDtoV2} patientInfoDtoV2 The patient information to store.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PatientInfoMetadataDtoV2}
     */

  }, {
    key: "patientinfoPost",
    value: function patientinfoPost(patientInfoDtoV2) {
      return this.patientinfoPostWithHttpInfo(patientInfoDtoV2).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Gets a paginated list of available patient information with the possibility of applying filters. (Requires: Roles -> RH.PI.ReadList, RH.PI.L, RH.PI.Admin).
     * @param {Object} opts Optional parameters
     * @param {Date} opts.dateTimeFrom The start date for retrieving patient information.
     * @param {Date} opts.dateTimeTo The end date for retrieving patient information.
     * @param {Number} opts.pageIndex Index of the page. The first page has index zero. (default to 0)
     * @param {Number} opts.pageSize Size of the page, that is the number of objects on a page. (default to 20)
     * @param {module:model/PatientInformationSearchFilter} opts.patientInformationSearchFilter Search filter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PatientInfoEntityDtoV2PaginatedList} and HTTP response
     */

  }, {
    key: "patientinfoSearchesPostWithHttpInfo",
    value: function patientinfoSearchesPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['patientInformationSearchFilter'];
      var pathParams = {};
      var queryParams = {
        'dateTimeFrom': opts['dateTimeFrom'],
        'dateTimeTo': opts['dateTimeTo'],
        'pageIndex': opts['pageIndex'],
        'pageSize': opts['pageSize']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['application/json'];
      var returnType = _PatientInfoEntityDtoV2PaginatedList["default"];
      return this.apiClient.callApi('/patientinfo/searches', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Gets a paginated list of available patient information with the possibility of applying filters. (Requires: Roles -> RH.PI.ReadList, RH.PI.L, RH.PI.Admin).
     * @param {Object} opts Optional parameters
     * @param {Date} opts.dateTimeFrom The start date for retrieving patient information.
     * @param {Date} opts.dateTimeTo The end date for retrieving patient information.
     * @param {Number} opts.pageIndex Index of the page. The first page has index zero. (default to 0)
     * @param {Number} opts.pageSize Size of the page, that is the number of objects on a page. (default to 20)
     * @param {module:model/PatientInformationSearchFilter} opts.patientInformationSearchFilter Search filter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PatientInfoEntityDtoV2PaginatedList}
     */

  }, {
    key: "patientinfoSearchesPost",
    value: function patientinfoSearchesPost(opts) {
      return this.patientinfoSearchesPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return PatientInfoApi;
}();

exports["default"] = PatientInfoApi;